import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from "@/components/ThemeProvider";
import { WebpagesProvider } from "@/contexts/WebpagesContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { OnboardingRoute } from "@/components/OnboardingRoute";
import { Home } from "@/pages/Home";
import { AuthCallback } from "@/pages/auth/callback";
import { Toaster } from "@/components/ui/toaster"
import { Saved } from "@/pages/Saved";
import { Privacy } from "@/pages/Privacy";
import { Terms } from "@/pages/Terms";
import { ExtensionAuth } from "@/pages/ExtensionAuth";
import { SearchPage } from "@/pages/search-page";
import { Settings } from "@/pages/Settings";
import { Upgrade } from "@/pages/Upgrade";
import { DocsIndex } from "@/pages/docs/DocsIndex";
import { McpDocs } from "@/pages/docs/McpDocs";
import { OnboardingStart } from "@/pages/onboarding/OnboardingStart";
import { OnboardingWelcome } from "@/pages/onboarding/OnboardingWelcome";
import { OnboardingMobile } from "@/pages/onboarding/OnboardingMobile";
import { useEffect } from 'react';
import { initializeExtensionSync } from '@/lib/auth/extension-sync';
import { usePageviewTracker } from '@/hooks/usePageviewTracker';

function LegacySaveRedirect() {
  const location = useLocation();
  return <Navigate to={`/saved${location.search}${location.hash}`} replace />;
}

// Lives inside <Router> so useLocation works.
function AnalyticsRouterHooks() {
  usePageviewTracker();
  return null;
}

export default function App() {
  useEffect(() => {
    // Initialize extension sync
    const cleanup = initializeExtensionSync();
    return () => cleanup();
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider defaultTheme="light" storageKey="scraper-theme">
        <WebpagesProvider>
          <Router>
            <AnalyticsRouterHooks />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/extension-auth" element={<ExtensionAuth />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/docs" element={<DocsIndex />} />
              <Route path="/docs/mcp" element={<McpDocs />} />
              <Route path="/save" element={<LegacySaveRedirect />} />
              <Route
                path="/saved"
                element={
                  <ProtectedRoute>
                    <Saved />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upgrade"
                element={
                  <ProtectedRoute>
                    <Upgrade />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/onboarding"
                element={
                  <OnboardingRoute>
                    <OnboardingStart />
                  </OnboardingRoute>
                }
              />
              <Route
                path="/onboarding/welcome"
                element={
                  <OnboardingRoute>
                    <OnboardingWelcome />
                  </OnboardingRoute>
                }
              />
              <Route
                path="/onboarding/mobile"
                element={
                  <OnboardingRoute>
                    <OnboardingMobile />
                  </OnboardingRoute>
                }
              />
            </Routes>
          </Router>
        </WebpagesProvider>
        <Toaster />
      </ThemeProvider>
    </HelmetProvider>
  );
}
